import React from "react";
import { Button } from "@/components/ui/button";
import { useDeleteOrganization } from "@/services/organizations.services";
import { toastErrorMessage, toastSuccessMessage } from "@/utils/helper/myToast";
import { Center } from "@/common/css";

interface DeleteOrganizationModalProps {
  organization: {
    id: number;
    name: string;
    [key: string]: any;
  };
  onClose: () => void;
  afterCall?: () => void;
}

const DeleteOrganizationModal: React.FC<DeleteOrganizationModalProps> = ({ organization, onClose, afterCall }) => {
  const deleteMutation = useDeleteOrganization();

  const handleDelete = async () => {
    try {
      const result = await deleteMutation.mutateAsync({ id: organization.id });
      if (result.status === 200 || result.status === 201) {
        toastSuccessMessage(result.data?.message || "Organization deleted successfully");
        afterCall?.();
        onClose();
      } else {
        toastErrorMessage(result.data?.message || "Failed to delete organization");
      }
    } catch (error: any) {
      const msg = error?.response?.data?.message || error.message || "Failed to delete organization";
      toastErrorMessage(msg);
    }
  };

  return (
    <div className="flex flex-col gap-4 p-4">
      <div className="text-sm text-text-default">
        Are you sure you want to delete the organization <strong>&quot;{organization.name}&quot;</strong>? This action cannot be undone.
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Button type="button" variant="outline" onClick={onClose} disabled={deleteMutation.isPending}>
          Cancel
        </Button>
        <Button type="button" variant="destructive" onClick={handleDelete} disabled={deleteMutation.isPending}>
          {deleteMutation.isPending ? (
            <Center className="gap-2">
              Deleting...
            </Center>
          ) : (
            "Delete"
          )}
        </Button>
      </div>
    </div>
  );
};

export default DeleteOrganizationModal;

